import formatNumbers from "../../../../helpers/formatNumbers";
import fetchRequest from "../fetchRequest";

/* eslint-disable camelcase */
class OffersBodyComponent {
    constructor(OS_DATA, offersBodyContainer, emitter) {
        this.paymentHeaderContainer = offersBodyContainer.querySelector(".cui-heading-2");
        this.paymentOptionsContainer = offersBodyContainer.querySelector('.payment-options__container');
        this.emitter = emitter;
        this.vehicleState = {};
        this.selectedPayment = "loan";
        this.selectedOffer = 0;
        this.OS_DATA = OS_DATA;

        this.emitter.on('new-vehicle-state', vehicleState => {
            this.init(vehicleState, this.fetchParams, this.personData);
        });
    }

    async init(vehicleState, fetchParams, personData) {
        this.vehicleState = vehicleState;
        this.fetchParams = fetchParams;
        this.personData = personData;

        this.paymentOptionsContainer.innerHTML = "";
        if (vehicleState) {
            this.vehicleState = vehicleState;
            this.selectedPayment = vehicleState.payments.selected;
            this.selectedOffer = vehicleState.payments[this.selectedPayment].selected_offer;
        }
        await this._updateOffers();
        this._updateHeader();
    }

    _handleToggleDetails(event) {
        event.preventDefault();
        const svgElem = event.target.querySelector('svg');
        const index = event.target.id.split('-')[2];

        const labelElem = this.paymentOptionsContainer.querySelector(`#label-item-${index}`.toString());
        const detailElem = this.paymentOptionsContainer.querySelector(`#copy-item-${index}`.toString());
        const open = (Array.from(labelElem.classList)).includes('expanded');

        /** IE 11 does not support class list on SVG elements, hence the
         * difference in methods for adding the 'expanded' class on that
         * element.
        */
        if (open) {
            let svgClasses = svgElem.getAttribute("class");
            svgClasses = svgClasses.replace("expanded", '');
            svgElem.setAttribute("class", svgClasses);

            labelElem.classList.remove('expanded');
            detailElem.classList.remove('expanded');
            detailElem.classList.add('hidden');
        } else {
            let svgClasses = svgElem.getAttribute("class");
            svgClasses += " expanded";
            svgElem.setAttribute("class", svgClasses);

            labelElem.classList.add('expanded');
            detailElem.classList.add('expanded');
            detailElem.classList.remove('hidden');
        }
    }

    async _handleChange(event) {
        if (event && event.target) {
            const selectedOfferIndex = parseInt(event.target.value, 10);
            const paymentObj = {};
            paymentObj[`${this.selectedPayment}`] = { selected_offer: selectedOfferIndex };

            this.vehicleState.payments = await fetchRequest.patchPayment(this.fetchParams, this.OS_DATA.vin, paymentObj);
            this.emitter.emit('new-offers', this.vehicleState);
        }
    }

    updateCreditRating(personData) {
        this.personData = personData;
        this._updateOffers();
    }

    async _updateOffers() {
        const offers = this.vehicleState.payments[this.selectedPayment].offers;

        if (offers && offers[0]) {
            this.paymentOptionsContainer.innerHTML = await this._buildOffers(offers);

            const newInputElems = Array.from(this.paymentOptionsContainer.querySelectorAll('.payment-offers__input-container'));

            if (this.selectedPayment !== "cash") {
                this.paymentOptionsContainer.querySelector(`#payment-option-${this.selectedOffer}`).checked = true;
            }

            let detailElem;
            newInputElems.map(elem => {
                detailElem = elem.querySelector('.payment-offers__option-details-right');
                if (this.selectedPayment !== "cash") {
                    elem.addEventListener("change", this._handleChange.bind(this));
                    detailElem.addEventListener("click", this._handleToggleDetails.bind(this));
                } else {
                    elem.addEventListener("click", this._handleToggleDetails.bind(this));
                }
            });
        }
    }

    _buildOffers(offers) {
        let paymentAmount, displayRate, fees, feeCopy, rateCopy, bestOffer, additionalData;
        const termLength = this.vehicleState.payments[this.selectedPayment].term;
        const msrp = this.vehicleState.msrp;
        const downPayment = this.vehicleState.payments[this.selectedPayment].down_payment;
        const leaseMiles = this.vehicleState.payments.lease.miles;
        const chevronPath = document.querySelector('[modal-id="online-shopper-modal"] .trade-in__option-icon use').getAttribute('xlink:href');

        return Promise.all(offers.map(async (offer, index) => {
            fees = offer.fees;
            feeCopy = this._feesCopy(fees);

            if (this.selectedPayment === 'cash') {
                return `
                    <div class="payment-offers__input-container">
                        <input class="payment-offers__option-input" type="radio" name="payment-offers-group" value="${index}" id="payment-option-${index}" />
                        <label class="payment-offers__option-label" id="label-item-${index}" for="payment-option-${index}">
                            <div class="payment-offers__option-details-container" id="cash-item-${index}">
                                <div class="payment-offers__option-details-left cash-option">
                                    <span class="payment-offers__option-payment">$${formatNumbers(offer.amount_financed, "money")}</span>
                                    <span class="payment-offers__option-copy">Estimated total</span> 
                                </div>
                                <div class="payment-offers__option-details-right" id="detail-item-${index}">
                                    Details
                                    <svg class="payment-offers__option-details-icon" height="16" width="16" viewbox="0 0 16 16">
                                        <use xlink:href=${chevronPath} />
                                    </svg>
                                </div>
                            </div>
                        </label>
                        <div class="payment-offers__details-copy hidden" id="copy-item-${index}" >
                            ${feeCopy}
                            
                            <div class="payment-offers__details-item">
                                Additional taxes, registration and license fees may apply for out of state purchasers based on their registration address. Price may include conditional loyalty and/or conquest incentives. Please contact us to confirm your eligibility. The delivery and handling charges represent costs and additional profits to the seller/dealership. Taxes are estimates. The dealership will help determine accurate taxes prior to delivery.
                            </div>
                        </div>
                    </div>
                `;
            }

            const lenderName = offer.lender;

            const lenderLogo = await fetchRequest.checkLenderLogo(this.fetchParams.apiBase, lenderName.toLowerCase().replace(/\s/g, "-"));
            const lenderImage = lenderLogo ? `<img class="payment-offers__option-logo" src="${lenderLogo}" alt="${lenderName}"/>` :
                `<svg class="payment-offers__option-logo no-photo" width="100" height="100" viewbox="0 0 172 185">
                    <use xlink:href="/cldstatic/vdp/%%FINGERPRINT%%/spritemap.svg#photo-not-available" />
                </svg>`;

            paymentAmount = formatNumbers(offer.payment, "money");
            displayRate = offer.interest_rate_display;

            rateCopy = this.selectedPayment === "loan" ? this._rateCopyLoan(offer, termLength) : this._rateCopyLease(offer, termLength, msrp, downPayment);
            bestOffer = index === 0 ? '<span class="payment-offers__best-offer-badge">BEST OFFER</span>' : "";
            additionalData = this.selectedPayment === "loan" ?
                `<span class="payment-offers__option-other"><p>${termLength} mos</p>` + `<p class="payment-offers__option-bar">|</p>` + `<p>${displayRate} APR</p></span>` :
                `<span class="payment-offers__option-other"><p>${termLength} mos</p>` + `<p class="payment-offers__option-bar">|</p>` + `<p>${leaseMiles / 1000}k</p></span>`;

            return `
                <div class="payment-offers__input-container">
                    <input class="payment-offers__option-input" type="radio" name="payment-offers-group" value="${index}" id="payment-option-${index}" />
                    <label class="payment-offers__option-label" id="label-item-${index}" for="payment-option-${index}">
                        <div class="payment-offers__option-logo-container">
                            ${lenderImage}
                        </div>
                        <div class="payment-offers__option-details-container">
                            <div class="payment-offers__option-details-left">
                                ${bestOffer}
                                <span class="payment-offers__option-payment">$${paymentAmount}/mo</span>
                                ${additionalData}
                            </div>
                            <div class="payment-offers__option-details-right" id="detail-item-${index}">
                                Details
                                <svg class="payment-offers__option-details-icon" height="16" width="16" viewbox="0 0 16 16">
                                    <use xlink:href=${chevronPath} />
                                </svg>
                            </div>
                        </div>
                    </label>
                    <div class="payment-offers__details-copy hidden" id="copy-item-${index}" >
                        ${feeCopy}
                        ${rateCopy}
                        <div class="payment-offers__details-item">
                            Additional taxes, registration and license fees may apply for out of state purchasers based on their registration address. Price may include conditional loyalty and/or conquest incentives. Please contact us to confirm your eligibility. The delivery and handling charges represent costs and additional profits to the seller/dealership. Taxes are estimates. The dealership will help determine accurate taxes prior to delivery.
                        </div>
                    </div>
                </div>
            `;
        })).then(allStuff => {
            return allStuff.join("").toString();
        });
    }

    _updateHeader() {
        let headerString;

        if (this.selectedPayment === "cash") {
            headerString = "Your cash deal";
        } else {
            headerString = "Choose your preferred payment option";
        }

        this.paymentHeaderContainer.innerHTML = headerString;
    }

    _feesCopy(fees) {
        if (fees && fees.length > 0) {
            let feeString = '';
            fees.map((fee, index) => {
                feeString += (fees.length > 1 && index === fees.length - 1) ? ' and ' : index > 0 ? ', ' : '';
                feeString += `${formatNumbers(fee.value, "currency")} ${fee.name}`;
            });
            return `
                <div class="payment-offers__details-item">
                    Registration and Fees include ${feeString}.
                </div>
            `;
        } else {
            return "";
        }
    }

    _rateCopyLoan(offer, termLength) {
        return `
            <div class="payment-offers__details-item">
                Rate subject to approval of credit with a credit score of ${this.personData.credit_estimate} or higher. Financing arranged through ${offer.lender}. Monthly payment includes all taxes and fees, and any manufacturer rebates. ${termLength} monthly payments of ${formatNumbers(offer.per_k, "currency")} per thousand borrowed.
            </div>
        `;
    }

    _rateCopyLease(offer, termLength, msrp, downPayment) {
        const totalPayments = offer.payment * termLength;
        return `
            <div class="payment-offers__details-item">
                Available only to qualified customers through ${offer.lender} at participating authorized dealers. Not everyone will qualify. Advertised ${termLength} month lease rate based on MSRP of $${formatNumbers(msrp, "money")}. Dealer contribution may vary and could affect your actual lease payment. Includes Destination charge and optional packages or equipment.  Total monthly payments equal ${formatNumbers(totalPayments, "currency")}. Cash due at signing includes $${formatNumbers(downPayment, "money")} capitalized cost reduction and first month’s lease payment of ${formatNumbers(offer.payment, "currency")}. No security deposit required. At lease end, lessee pays for any amounts due under the lease, any official fees and taxes related to the scheduled termination, excess wear and use. Purchase option at lease end for ${formatNumbers(offer.residual, "currency")} plus taxes in example shown. Subject to credit approval. See dealer for complete details.
            </div>
        `;
    }
}

export default OffersBodyComponent;